import { ACTION_TYPES } from '../../constants/store.constants';

const updateImageDescription = (imageId, description) => {
  return {
    type: ACTION_TYPES.UPDATE_IMAGE_DESCRIPTION,
    payload: { imageId, description }
  };
};

const addSelectedImage = image => {
  return {
    type: ACTION_TYPES.ADD_SELECTED_IMAGE,
    payload: image
  };
};

const removeSelectedImage = imageId => {
  return {
    type: ACTION_TYPES.REMOVE_SELECTED_IMAGE,
    payload: imageId
  };
};

const clearSelectedImages = () => {
  return {
    type: ACTION_TYPES.CLEAR_SELECTED_IMAGES
  };
};

const updateImagesUploadStatus = uploadStatusMap => {
  return {
    type: ACTION_TYPES.UPDATE_IMAGE_STATUS,
    payload: uploadStatusMap
  };
};

const resetImagesUploadStatus = () => {
  return {
    type: ACTION_TYPES.RESET_IMAGE_STATUS
  };
};

const setDisplayUploadServiceErrorNotification = status => {
  return {
    type: ACTION_TYPES.SET_DISPLAY_UPLOAD_SERVICE_ERROR_NOTIFICATION,
    payload: status
  };
};

const setDisplayPartialErrorNotification = status => {
  return {
    type: ACTION_TYPES.SET_DISPLAY_PARTIAL_ERROR_NOTIFICATION,
    payload: status
  };
};

const setImageIdBeingEdited = imageId => {
  return {
    type: ACTION_TYPES.SET_IMAGEID_BEING_EDITED,
    payload: imageId
  };
};

const disableImageListInteraction = status => {
  return {
    type: ACTION_TYPES.DISABLE_IMAGE_LIST_INTERACTION,
    payload: status
  };
};

export default {
  updateImageDescription,
  addSelectedImage,
  removeSelectedImage,
  clearSelectedImages,
  updateImagesUploadStatus,
  setDisplayUploadServiceErrorNotification,
  setDisplayPartialErrorNotification,
  resetImagesUploadStatus,
  setImageIdBeingEdited,
  disableImageListInteraction
};
